var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header", [
        _c("div", { staticClass: "headertitle" }, [
          _c(
            "a",
            {
              staticClass: "headertitle-home",
              attrs: { href: "/", title: "Home", "aria-label": "Home" },
            },
            [
              _c("i", {
                staticClass: "fas fa-home",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("a", { attrs: { href: "/" } }, [
            _vm._v("\n                Europe 40 Under 40"),
            _c("span", { staticClass: "copyright" }, [_vm._v("®")]),
            _vm._v("\n                AWARD\n            "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 6, lg: 4 } }, [
            _vm.$auth.user()
              ? _c(
                  "div",
                  { staticClass: "side-menu-frame" },
                  [
                    _c("router-link", { attrs: { to: _vm.accountLink } }, [
                      _vm._v("Account"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.reloadPageWhenRouteTheSame()
                          },
                        },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "europe40under40-design-award-form" },
                            },
                          },
                          [_vm._v("New Submission")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("router-link", { attrs: { to: _vm.submissionLink } }, [
                      _vm._v("My Submissions"),
                    ]),
                  ],
                  1
                )
              : _c("div", [_vm._v(" ")]),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 18, lg: 12 } },
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("FooterAlt", [
        _c("div", { staticClass: "footerlogo-caption" }, [
          _vm._v(
            "\n            Europe 40 Under 40 Awards ™ is a Federally Registered and\n            Protected U.S. Trademark of The Chicago Athenaeum. Copyright ©\n            1992 - 2026 The European Centre for Architecture Art Design and\n            Urban Studies\n        "
          ),
        ]),
        _vm._v(" "),
        _c("img", { attrs: { src: "/images/EUROPE40UNDER50-LOGO.png" } }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }